export default {
  // nav
  home: "الرئيسية",
  suppliers: "الموردين",
  corporat: "تسجيل الشركات",
  buyer: "المشتري",
  contactUs: "اتصل بنا",
  mySupply: "ماي سبلاي",
  allRightsReserved: " جميع الحقوق محفوظة",
  bestDeal: "أفضل الصفقات",
  dailyOffers: "العروض اليومية",
  monthlyOffers: "العروض الخاصه",
  about: "عن الشركة",
  vision: "رؤية الشركة",
  message: "رسالة الشركة",
  myPrinciples: "مبادئ الشركة",
  registerForTheNewsletter: "التسجيل في النشرة الإخبارية",
  beTheFirstToGetExclusiveOffersAndCoupons:
    "كن أول من يحصل على عروض وكوبونات حصرية",
  subscribe: "الإشتراك",
  email: "عنوان بريد الكتروني",
  kuwait: "الكويت",
  cart: "سلة المشتريات",
  KWD: "الدينار الكويتي",
  USD: "الدولار الامريكي",
  showAll: "عرض الكل",
  noData: "لا يوجد بيانات ",
  tilNow: "حتي الان",
  noDataTill: "لا يوجد بيانات حتي الان",
  All: "الكل",
  vendors: "تسجيل الموردين",
  pageNoteFound1: "الصفحة التي تبحث عنها ليست موجودة.",
  you: "انت",
  ok: "أوافق",
  privacyPolicy: "سياسة الخصوصيه",
  termsConditions: "الشروط و الاحكام",
  faq: "الأسئلة الشائعة",
  siteName: "فريق دعم HumHumm",
  siteSupport: "الرد غالبا يكون خلال ساعة",
  hiThere: "مرحبا",
  helpYou: "كيف يمكننى مساعدتك ؟",
  startCaht: "ابدأ المحادثه",
  navSuppliers: "الشركاء",
  clients: "العملاء",
  consumerCategory: "فئة المستهلك",
  corporateCategory: "فئة الشركة",
  registerThank: "شكرا على انشاء حساب",
};
